import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { usePaymnetContext } from "../..";
import Loader from "../../Loader/Loader";
import { fetchPaymentPartnersAPI } from "../apiSercive";
import { getQueryStringValue, IPaymentPartner, PREVIEW_MODE } from "../common";
import { PaymentAmount, PaymentButton, PaymentVendor } from "./payment.card";

interface ISetp2 {
    loading: boolean;
    setLoading: (loading: boolean) => void;
    onPaymentSelect: (item: any) => void;
}

const Step2 = memo(({ loading, setLoading, onPaymentSelect }: ISetp2) => {
    const { t } = useTranslation();
    const { state, update } = usePaymnetContext();

    const getPaymentPartners = () => {
        const paymentLinkId = getQueryStringValue("id");

        if (state.mode === PREVIEW_MODE) {
            const paymentPartners: IPaymentPartner[] = [
                {
                    "id": "3644fb95-9331-47a6-beb0-fe6eaf6337d7",
                    "logoUrl": "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/airtel.svg",
                    "partnerName": "Airtel-Tz",
                    "provider": "2",
                    partnerType: "mno",
                    "vendorName": "Daraz102",
                    "paymentVendorId": "6ed0a429-dbdb-4aa9-9187-c4429edd2368",
                    "paymentPartnerId": "08d9945a-c9df-4834-876e-04b2df375d8e",
                    "paymentAcknowledgmentRoute": "https//:daraz102.com/callback",
                    "currency": "Tsh",
                    "status": "1",
                    "vendorType": "seller"
                },
                {
                    "id": "36a721ac-2fa1-46ff-8e01-84664fe513cd",
                    "logoUrl": "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/tigopesa.svg",
                    "partnerName": "Tigopesa",
                    "provider": "3",
                    partnerType: "mno",
                    "vendorName": "Daraz102",
                    "paymentVendorId": "6ed0a429-dbdb-4aa9-9187-c4429edd2368",
                    "paymentPartnerId": "8f2b5341-78c1-4aa2-a8a4-0e1fbe263f1c",
                    "paymentAcknowledgmentRoute": "https//:daraz102.com/callback",
                    "currency": "Tsh",
                    "status": "1",
                    "vendorType": "seller"
                },
                {
                    "id": "e470169c-2b3b-49d8-b97c-c9a79e869614",
                    "logoUrl": "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/halopesa.svg",
                    "partnerName": "Halopesa",
                    "provider": "4",
                    "vendorName": "Daraz102",
                    "paymentVendorId": "6ed0a429-dbdb-4aa9-9187-c4429edd2368",
                    "paymentPartnerId": "08d99549-2d49-4694-8320-f60b4e76be6a",
                    "paymentAcknowledgmentRoute": "https//:daraz102.com/callback",
                    "currency": "Tsh",
                    "status": "1",
                    partnerType: "mno",
                    "vendorType": "seller"
                },
                {
                    "id": "ff3b06be-54f1-48a3-b10f-a488ce905075",
                    "logoUrl": "https://azampay-sarafutest.s3.eu-central-1.amazonaws.com/azampesa.png",
                    "partnerName": "Azampesa",
                    "provider": "5",
                    "vendorName": "Daraz102",
                    "paymentVendorId": "6ed0a429-dbdb-4aa9-9187-c4429edd2368",
                    "paymentPartnerId": "08d997ae-1961-4c32-8b2f-e00f53003b00",
                    "paymentAcknowledgmentRoute": "https//:daraz102.com/callback",
                    "currency": "Tsh",
                    "status": "1",
                    partnerType: "mno",
                    "vendorType": "seller"
                }
            ]
            update({ ...state, paymentPartners })
        } else {
            setLoading(true);
            fetchPaymentPartnersAPI(paymentLinkId).then((data: any) => {
                if (data.status === 200 && data.data && data.data.length > 0) {
                    const paymentPartners: IPaymentPartner[] = data.data;
                    update({
                        ...state, paymentPartners
                    })
                }
                setLoading(false);
            }).catch((error: any) => {
                setLoading(false);
                update({
                    ...state,
                    success: false,
                    systemMessage: {
                        ...state.systemMessage,
                        show: true,
                        title: error?.code,
                        message: error.message
                    }
                });
            });
        }

    }
    useEffect(() => {
        getPaymentPartners();
    }, []);

    if (loading) return <Loader />

    const defaultPaymentPartner = state.paymentPartners.find((item: any) => item.provider == "5");
    const otherPaymentPartners = state.paymentPartners.filter((item: any) => item.provider != "5");
    return <>
        <PaymentVendor />
        <PaymentAmount />
        {defaultPaymentPartner &&
            <>
                <PaymentButton
                    className="default"
                    src={defaultPaymentPartner.logoUrl}
                    alt={"azam pesa"}
                    btnIcon="https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/short-arrow-right-dark.svg"
                onClick={() => onPaymentSelect({ ...defaultPaymentPartner, provider: defaultPaymentPartner.provider, id: defaultPaymentPartner.id, isMno: false })}
                >
                    {t("payWith")}
                </PaymentButton>
                {state.paymentPartners.length > 1 && <hr className="line" />}
            </>
        }
        {otherPaymentPartners.length > 0 && <div className="payment-methods-wrapper">
            {defaultPaymentPartner && <div className="title">{t("orPayWith")}</div>}
            {otherPaymentPartners.filter((item: any) => item.provider != 5).map((item: any) => {
                return <PaymentButton
                    key={item.id}
                    className="others"
                    src={item.logoUrl || "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/default-mno.svg"}
                    btnIcon="https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/short-arrow-right-white.svg"
                    alt={item.partnerName}
                    onClick={() => onPaymentSelect({ ...item, isMno: true })}
                >
                    {item.partnerName}
                </PaymentButton>
            })}
        </div>
        }
    </>
});

export default Step2;
